import React from 'react'
import '../../Styles/AdditionalPages/Testimonial.css'

export default function Testimonial() {
  return (
    <div className='testimonials'>
        Work under process
    </div>
  )
}
